import { render, staticRenderFns } from "./Puzzles.vue?vue&type=template&id=448ccdc0&scoped=true&"
import script from "./Puzzles.vue?vue&type=script&lang=js&"
export * from "./Puzzles.vue?vue&type=script&lang=js&"
import style0 from "./Puzzles.vue?vue&type=style&index=0&id=448ccdc0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448ccdc0",
  null
  
)

export default component.exports